import React from 'react';
import { Tabs } from '@metarouter-private/mr-mui';

import { useTransformPlaybookContext } from 'app/context/transform-playbook-context';
import { useDisabledTabs } from 'app/playbook-editor/transform-drawer/useDisabledTabs';
import InputEditor from 'app/playbook-editor/transform-drawer/components/InputEditor';
import OutputEditor from 'app/playbook-editor/transform-drawer/components/OutputEditor';
import useBasicTransform from './useBasicTransform';

// Basic mode: the original two-tab Test Playbook flow.
export default function BasicTabsSection() {
  const { clusterId, hasValidInput } = useTransformPlaybookContext();
  const disabledTabs = useDisabledTabs(clusterId, hasValidInput);
  const { onClickOutputTab } = useBasicTransform();

  return (
    <Tabs
      tabs={[
        { label: 'Input Event', content: <InputEditor /> },
        {
          label: 'Output Event',
          content: <OutputEditor />,
          TabProps: {
            disabled: disabledTabs.outputEvent.disabled,
            disabledTooltip: disabledTabs.outputEvent.disabledMessage,
            onClick: onClickOutputTab,
          },
        },
      ]}
    />
  );
}
